import { Classes } from "@blueprintjs/core";
import styled from "@emotion/styled";

import { Box } from "@/components/layout/flexbox";
import { breakpoints } from "@/components/layout/Media";
import { RoleplayDetails } from "@/components/pages_logged_in/roleplays/RoleplayDetails";
import {
  FullRoleplay,
  PaginatedRoleplay,
  RoleplayViewMode,
} from "@/types/roleplays";

interface RoleplayListProps {
  roleplays: PaginatedRoleplay[];
  loading: boolean;
  onChoose?: (roleplay: PaginatedRoleplay) => void;
  showNumScenarios?: boolean;
  showProgress?: boolean;
  showActionBar?: boolean;
  viewMode?: RoleplayViewMode;
  visibleTitle?: boolean;
  refetchRoleplays?: () => void;
}

export function RoleplayList({
  roleplays,
  loading,
  onChoose,
  showNumScenarios = true,
  showProgress = true,
  showActionBar = false,
  viewMode = "column",
  refetchRoleplays,
}: RoleplayListProps) {
  if (loading) {
    return (
      <List
        className={
          viewMode === "list" ? "roleplay-list-view" : "roleplay-column-view"
        }
      >
        <Box height={210} className={Classes.SKELETON} />
        <Box height={210} className={Classes.SKELETON} />
        <Box height={210} className={Classes.SKELETON} />
        <Box height={210} className={Classes.SKELETON} />
      </List>
    );
  }

  return (
    <Box my={16} mt={viewMode === "list" ? 0 : 4}>
      <List
        className={
          viewMode === "list" ? "roleplay-list-view" : "roleplay-column-view"
        }
      >
        {roleplays.map((roleplay) => (
          <RoleplayDetails
            key={roleplay.id}
            roleplay={roleplay as FullRoleplay}
            onChoose={onChoose}
            showNumScenarios={showNumScenarios}
            showProgress={showProgress}
            showActionBar={showActionBar}
            viewMode={viewMode}
            refetchRoleplays={refetchRoleplays}
          />
        ))}
      </List>
    </Box>
  );
}

export const List = styled("div")`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  padding: 0;

  &.roleplay-list-view {
    display: flex;
    flex-direction: column;
  }

  @media screen and (max-width: ${breakpoints.ml - 1}px) {
    grid-template-columns: 1fr;
  }
`;
